const actions = {
  CREATE_CODE_GENERATOR: 'CREATE_CODE_GENERATOR',
  CREATE_CODE_GENERATOR_ENDED: 'CREATE_CODE_GENERATOR_ENDED',
  SEARCH_CODE_GENERATORS: 'SEARCH_CODE_GENERATORS',
  SEARCH_CODE_GENERATORS_ENDED: 'SEARCH_CODE_GENERATORS_ENDED',
  FIND_CODE_GENERATOR: 'FIND_CODE_GENERATOR',
  FIND_CODE_GENERATOR_ENDED: 'FIND_CODE_GENERATOR_ENDED',
  UPDATE_CODE_GENERATOR: 'UPDATE_CODE_GENERATOR',
  UPDATE_CODE_GENERATOR_ENDED: 'UPDATE_CODE_GENERATOR_ENDED',
  DELETE_CODE_GENERATORS: 'DELETE_CODE_GENERATORS',
  DELETE_CODE_GENERATORS_ENDED: 'DELETE_CODE_GENERATORS_ENDED',
};

export default actions;
